<template>
    <section class="login">
        <div class="container-scroller forgot-container-scroller">
            <div class="container-fluid page-body-wrapper full-page-wrapper forgot-full-page-wrapper">
                <div class="content-wrapper d-flex align-items-center auth forgot-content-wrapper">
                    <div class="row w-100 flex-grow">
                        <div class="col-xl-4 col-lg-6 mx-auto">
                            <div class="auth-form-light text-left">
                                <div class="brand-logo text-center">
                                    <router-link to="/">
                                        <img src="../public/assets/images/Vanovy-Logo.svg" alt="Vanovy Logo" />
                                    </router-link>
                                </div>
                                <div class="auth-form">
                                    <form>
                                        <div class="form-fields">
                                            <b-form-group>
                                                <b-form-input id="input-1" type="email" placeholder="Email Address"
                                                    v-model="email" :state="$v.email.$dirty ? !$v.email.$invalid : null"
                                                    aria-describedby="input-2-live-feedback"></b-form-input>
                                                <b-form-invalid-feedback v-if="$v.email.$dirty && !$v.email.required"
                                                    id="input-2-live-feedback">
                                                    This is a required field.
                                                </b-form-invalid-feedback>
                                                <b-form-invalid-feedback v-if="$v.email.$dirty && !$v.email.email"
                                                    id="input-2-live-feedback">
                                                    Invalid email format
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>

                                        <div class="form-group text-center m-t-20 mb-2 mt-3">
                                            <button type="button" :disabled="isDisabled"
                                                class="btn btn-primary btn-block btn-lg waves-effect waves-light"
                                                @click="login()">
                                                Send Email
                                            </button>
                                        </div>

                                        <div class="social-login text-center">
                                            <router-link to="/" class="btn">
                                                <i class="fa fa-arrow-left m-right-5"></i><span>Back</span>
                                            </router-link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
        <div class="col-md-4 col-sm-6 grid-margin stretch-card" v-if="isHide">
            <div class="loader-demo-box">
                <div class="dot-opacity-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import API from '@/api';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import Footer from '../layout/partials/Footer';

export default {
    name: 'Forget-Password',
    mixins: [validationMixin],
    components: {
        Footer
    },
    data() {
        return {
            email: '',
            isDisabled: false,
            isHide: false,
        };
    },
    validations: {
        email: {
            required,
            email
        }
    },
    watch: {
        email(newVal) {
            localStorage.setItem('reset_email', newVal);
        }
    },
    beforeMount() {
        const storedEmail = localStorage.getItem('reset_email');
        if (storedEmail) {
            this.email = storedEmail;
        }
    },
    methods: {
        login() {
            this.$v.$touch();
            if (this.$v.email.$anyError) {
                return;
            }

            this.isDisabled = true;
            const data = { email: this.email };

            API.checkEmail(
                data,
                res => {
                    if (res.status === 200) {
                        this.$swal({
                            icon: 'success',
                            type: 'success',
                            title: 'Success',
                            text: res.message
                        });
                        localStorage.removeItem('reset_email');
                        this.email = '';
                        this.$v.$reset();
                    } else {
                        this.$swal({
                            icon: 'error',
                            type: 'error',
                            title: 'Oops...',
                            text: res.message
                        });
                    }
                    this.isDisabled = false;
                },
                err => {
                    this.isDisabled = false;
                    this.$swal({
                        icon: 'error',
                        type: 'error',
                        title: 'Oops...',
                        text: err.message
                    });
                }
            );
        }
    }
};
</script>